import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../../shared/auth/auth-guard.service';
import { UserslistComponent } from './userslist.component';



const routes: Routes = [
  {
    path: '',
     component: UserslistComponent,
    data: {
      title: 'Userslist'
    },    
    canActivate: [AuthGuard] 
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UserListRoutingModule { }